var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"disparity",class:{'is-up': _vm.value > 0, 'is-down': _vm.value < 0}},[(_vm.value < 0)?_c('span',[_c('i',{staticClass:"fa fa-caret-down"})]):_vm._e(),(_vm.value > 0)?_c('span',[_c('i',{staticClass:"fa fa-caret-up"})]):_vm._e(),_vm._v(_vm._s(_vm._f("round")(_vm._f("abs")(_vm.value),1, true))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }